if (!customElements.get('home-reviews')) {
  customElements.define('home-reviews', class HomeReviews extends HTMLElement {
    constructor() {
      super();
      this.sliderEl = this.querySelector('[data-flickity-config]');
      this.sliderConfig = JSON.parse(this.sliderEl.dataset.flickityConfig);
      this.isDesktop = window.matchMedia('(min-width: 1008px)').matches;
      
      if (this.isDesktop) {
        this.sliderConfig.wrapAround = false;
        this.sliderConfig.cellAlign = "left";
      }
      
      // window.addEventListener('resize', debounce(this.setHeight, 100));
      this.setHeight();
      this.init();
    }
    
    init() {
      this.flckty = new Flickity(this.sliderEl, this.sliderConfig);
    }
    
    setHeight() {
      const maxHeight = Array.from(document.querySelectorAll('.home-reviews__grid-item')).map((item) => item.clientHeight).sort(function(a, b){return b - a})[0];
      this.style.setProperty('--review-item-height', `${maxHeight}px`);
    }

  });
}
